<div class="billing-alert-wrapper" (click)="handleSubscription()">
    <div class="billing-alert-heading">
        <div class="d-flex align-items-center">
            <ng-icon class="billing-alert-icon" [name]="icon" [size]="'20px'" [color]="'#9F1239'"
                [strokeWidth]="'2'"></ng-icon>
            <div class="billing-alert-heading-text">{{heading | translate}}</div>
        </div>
        <ng-icon [name]="'heroArrowUpRight'" [size]="'16px'" [color]="'#9F1239'" [strokeWidth]="'2'"></ng-icon>
    </div>
    <div class="billing-alert-description">
        {{description | translate}}
    </div>
</div>
